module.exports = {
  FACEBOOK_SHARE_URL: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.ecosia.org&ref=share',
  FACEBOOK: 'https://www.facebook.com/ecosia',
  FAQ: 'https://ecosia.zendesk.com/hc',
  GIFTING_TREES: 'https://plant.ecosia.org',
  HOTELS2_DESKTOP_URL: 'https://hotels2.ecosia.org/?aid=1721236&exp_sal_ecosia_disable_ga=1',
  HOTELS2_MOBILE_URL: 'https://hotels2.ecosia.org/?aid=1760491&exp_sal_ecosia_disable_ga=1',
  INSTAGRAM: 'https://www.instagram.com/ecosia',
  JOBS: 'https://jobs.lever.co/ecosia',
  LINKEDIN: 'https://www.linkedin.com/company/ecosia',
  MICROSOFT_PRIVACY: 'https://privacy.microsoft.com/privacystatement',
  SHOP: 'https://ecosia.teemill.com',
  TREECARD: 'https://ecosia.co/footer',
  TREEDAY_URL: 'https://www.treeday.net/search',
  TWITTER: 'https://twitter.com/ecosia',
  YOUTUBE: 'https://www.youtube.com/user/EcosiaORG',
  ZENDESK_GUIDE_TO_GREENER_SEARCH: 'https://ecosia.zendesk.com/hc/articles/360013117973',
  ZENDESK_LEARN_MORE_LINK_BETA: 'https://ecosia.zendesk.com/hc/articles/360030310374',
  ZENDESK_LEARN_MORE_LINK: 'https://ecosia.zendesk.com/hc/articles/201657341',
  ZENDESK_PERSONALIZED_SEARCH: 'https://ecosia.zendesk.com/hc/articles/214375485',
  ZENDESK_AD_LEARN_MORE_URL: 'https://ecosia.zendesk.com/hc/articles/201657811',
};
